<template>
	<div id="commit" class="jon-slider">
		<h3 class="text-center mt-5" style="line-height: 1.5em"><b class="text-gradient">Commit</b></h3>
		<p class="text-center font-courier text-gold">Beberapa commit yang baru anda buat</p>
		<div>
			<div v-for="(cm) in commit" :key="cm.id" class="commit-item">
				<span class="mr-3">
					<img class="avatar" :src="profil.avatar_url" width="32" height="32">
				</span>
				<div style="width: 100%">
					<div>
						<a href="/" target="_blank"><b>{{cm.actor.login}}</b></a> pushed to <a href=""><b>{{cm.repo.name}}</b></a> <small>{{cm.created_at}}</small>
						<div class="commit-detail p-3 mt-2">
							<span>{{cm.payload.size}} commit to</span>
							<a href="" class="gh-branch-name">{{cm.payload.ref}}</a>
							<div class="mt-1">
								<ul style="list-style: none; padding: 0">
									<li style="display: flex;">
										<span>
											<img class="avatar mr-1" :src="profil.avatar_url" width="16" height="16">
										</span>
										<code class="mr-1">{{cm.payload.head.substr(0, 8)}}</code>
										<blockquote style="margin:0"><small>{{(cm.payload.commits[0]) ? cm.payload.commits[0].message : ''}}</small></blockquote>
									</li>
								</ul>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div v-if="stat.commit > 1" class="section-fade"></div>
		<div class="review-commit">
			<div class="row">
				<div class="col-md-6">
					<p class="text-center">Jumlah Commit Sampai Saat Ini</p>
					<CounterStyle identify="statcommit" :value="stat.commit" :key="3"></CounterStyle>
				</div>
				<div class="col-md-6">
					<p class="text-center">Jumlah Commit Yang Ingin Anda Capai (2021)</p>
					<CounterStyle identify="resocommit" :value="resolution.commit" :is_res="true" :key="4"></CounterStyle>
				</div>
			</div>
			<ReviewBox :stat="stat.commit" :reso="resolution.commit" :progress="progress.commit" identify="commit" :key="2"></ReviewBox>
		</div>
	</div>
</template>

<script>
import CounterStyle from './../components/CounterStyle'
import ReviewBox from './../components/ReviewBox'
export default {
	data(){
		return {
			// number: []
		}
	},
	components: {
		CounterStyle, ReviewBox
	},
	props: ['stat', 'resolution', 'progress', 'commit', 'profil'],
	methods: {

	},
	mounted(){

	}
}
</script>

<style>
	
</style>